<p class="mb-16" [ngClass]="(client === 'xfinity' || 'xfinitystream') ? 'text-title-4' : 'text-title-6 '">
{{ subHeader | translate }}</p>
<p class="mb-8" [ngClass]="(client === 'xfinity' || 'xfinitystream') ? 'text-body-lg' : 'text-title-8'">
{{ header | translate }}</p>
<p class="mb-24 text-body-lg"></p>
<div class="mb-16">
  <div class="text-center">
    <button ds-button
      type="submit"
      #submitLogin
      role="button"
      class="w-100 mb-16"
      (click)="onRogersSignInClick()"
      title="{{ rogersLabel | translate }}">
      @if (!isRogersSelected) {
        <span>{{ rogersLabel | translate}}</span>
      }
      @if (loginInProgress && isRogersSelected) {
        <eas-loader class="eas-loader"></eas-loader>
      }
    </button>
  </div>

  <div class="text-center">
    <button ds-button
      type="submit"
      #submitLogin
      role="button"
      class="w-100 mb-16"
      (click)="onShawSignInClick()"
      title="{{ shawLabel | translate }}">
      @if (!isShawSelected) {
        <span>{{shawLabel | translate}}</span>
      }
      @if (loginInProgress && isShawSelected) {
        <eas-loader class="eas-loader"></eas-loader>
      }
    </button>
  </div>
</div>

<!-- <div [class]="recaptchaClass" (outsideClick)="outsideClickCapture()">
<re-captcha
  *ngIf="useRecaptchaV3"
  #captchaRefV3="reCaptcha"
  [siteKey]="reCaptchaV3SiteKey"
  size="invisible"
  [badge]="recaptchaBadge"
  [actionName]="'username'"
  (resolved)="$event && processRecaptcha($event)"
></re-captcha>
<re-captcha
  *ngIf="!useRecaptchaV3"
  #captchaRef="reCaptcha"
  [siteKey]="reCaptchaSiteKey"
  size="invisible"
  [badge]="recaptchaBadge"
  (resolved)="$event && processRecaptcha($event)">
</re-captcha>
</div> -->